import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import Select from '../../../components/ui/Select';

const GlobalControls = ({ 
  selectedDateRange, 
  onDateRangeChange, 
  selectedCampaign, 
  onCampaignChange,
  autoRefreshInterval,
  onAutoRefreshChange,
  isAutoRefreshEnabled,
  onToggleAutoRefresh,
  campaigns = []
}) => {
  const [isRefreshing, setIsRefreshing] = useState(false);

  const dateRangeOptions = [
    { value: 'last24h', label: 'Last 24 Hours' },
    { value: 'last7d', label: 'Last 7 Days' },
    { value: 'last30d', label: 'Last 30 Days' },
    { value: 'last90d', label: 'Last 90 Days' },
    { value: 'last6m', label: 'Last 6 Months' },
    { value: 'last12m', label: 'Last 12 Months' },
    { value: 'custom', label: 'Custom Range' }
  ];

  const refreshIntervalOptions = [
    { value: 30, label: '30 seconds' },
    { value: 60, label: '1 minute' },
    { value: 300, label: '5 minutes' },
    { value: 0, label: 'Manual only' }
  ];

  const campaignOptions = [
    { value: 'all', label: 'All Campaigns' },
    ...campaigns?.map(campaign => ({
      value: campaign?.id,
      label: campaign?.name
    }))
  ];

  const handleManualRefresh = async () => {
    setIsRefreshing(true);
    // Simulate refresh delay
    await new Promise(resolve => setTimeout(resolve, 1000));
    setIsRefreshing(false);
    // Trigger actual refresh logic here
  };

  return (
    <div className="bg-card border-b border-border p-6">
      <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between space-y-4 lg:space-y-0">
        {/* Left side controls */}
        <div className="flex flex-col sm:flex-row sm:items-center space-y-3 sm:space-y-0 sm:space-x-4">
          <Select
            label="Date Range"
            options={dateRangeOptions}
            value={selectedDateRange}
            onChange={onDateRangeChange}
            className="w-full sm:w-48"
          />
          
          <Select
            label="Campaign"
            options={campaignOptions}
            value={selectedCampaign}
            onChange={onCampaignChange}
            className="w-full sm:w-48"
          />
        </div>

        {/* Right side controls */}
        <div className="flex flex-col sm:flex-row sm:items-center space-y-3 sm:space-y-0 sm:space-x-3">
          <div className="flex items-center space-x-2">
            <Select
              label="Auto Refresh"
              options={refreshIntervalOptions}
              value={autoRefreshInterval}
              onChange={onAutoRefreshChange}
              className="w-32"
            />
            
            <Button
              variant={isAutoRefreshEnabled ? 'default' : 'outline'}
              size="sm"
              iconName={isAutoRefreshEnabled ? 'Pause' : 'Play'}
              onClick={onToggleAutoRefresh}
              className="mt-6"
            >
              {isAutoRefreshEnabled ? 'Pause' : 'Start'}
            </Button>
          </div>

          <Button
            variant="outline"
            size="sm"
            iconName={isRefreshing ? 'Loader2' : 'RefreshCw'}
            onClick={handleManualRefresh}
            disabled={isRefreshing}
            className={`mt-6 ${isRefreshing ? 'animate-spin' : ''}`}
          >
            Refresh
          </Button>
        </div>
      </div>
      {/* Status indicators */}
      <div className="flex flex-wrap items-center justify-between mt-4 pt-4 border-t border-border">
        <div className="flex items-center space-x-4 text-sm text-muted-foreground">
          <div className="flex items-center space-x-2">
            <div className="w-2 h-2 bg-success rounded-full animate-pulse"></div>
            <span>Live data connection</span>
          </div>
          
          <div className="flex items-center space-x-2">
            <Icon name="Clock" size={14} />
            <span>Last updated: {new Date()?.toLocaleTimeString()}</span>
          </div>
        </div>

        <div className="flex items-center space-x-2 text-sm">
          <Icon name="Database" size={14} className="text-muted-foreground" />
          <span className="text-muted-foreground">
            Showing data for: {campaignOptions?.find(c => c?.value === selectedCampaign)?.label}
          </span>
        </div>
      </div>
    </div>
  );
};

export default GlobalControls;